import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE } from "../data/content";

export const Ribbon = () => (
  <div className="bg-[#21070D] py-6 sm:py-8 border-y border-[#C69B5F]/20 overflow-hidden w-full" data-testid="marquee">
    <Marquee speed={40} gradient={false} autoFill>
      {MARQUEE.map((word, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-2xl sm:text-4xl text-[#F4EBD9] px-8">
            {word}
          </span>
          <span className="text-[#D9B24A] text-xl sm:text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
